module.exports = "/wp-content/themes/world-coal-association/public/dist/svgs/button-underline.svg";